import { ServiceConfig } from 'angular-odata';

//#region ODataApi Imports
//#endregion

export const KundenFilterDtoServiceConfig = {
  name: "KundenFilterDto",
  annotations: []
} as ServiceConfig;